import PropTypes from "prop-types";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = ({ children, page }) => {
  return (
    <>
      <Header page={page} />
      <main id="main">{children}</main>
      <Footer />
    </>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
};

export default MainLayout;
